import React, {Component} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from 'react-redux';
import TiresExchange from "./TiresExchange";
import TiresReplacement from "./TiresReplacement";

import "./AppointmentServicesCard.css";
import InterventionService from "../../../services/Intervention";
import Constants from "../../../services/Constants";
import ValueServicesCart from "./ValueServicesCart";
import Checkbox from "../../../public/journey1/fragments/services/Checkbox";
import Card from "../../common/Card";

class AppointmentServicesCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pristine: false
    }
  }

  componentDidMount() {
    const {journey: {properties = {}} = {}} = this.props.intervention;
    if (properties.services) {
      const {services: {services, tiresExchange, tiresReplacement}} = properties;
      this.setState({requestedServices: services, tiresExchange, tiresReplacement})
    }
    this.props.dispatchFetchServices();
  }

  onServicesSave = () => {
    const {intervention: {journey: {id, properties}, origin}, cart} = this.props;
    const {requestedServices, tiresExchange, tiresReplacement} = this.state;

    const oas = origin === 'OAS';

    let body = {type: Constants.TYPE_APPOINTMENT.value, services: requestedServices.map(r => oas ? r.id : r.name)};
    if (body.services.includes("tiresExchange")) {
      body.tiresExchange = tiresExchange;
    }
    if (body.services.includes("tiresReplacement")) {
      body.tiresReplacement = tiresReplacement;
    }
    if (properties.services.valueServicesCart){
      body.bookingToken = properties.services.valueServicesCart.bookingToken;
    }
    this.props.dispatchUpdateServices(id, body);
  };

  onServicesChange = (e, service) => {
    const {target: {checked}} = e;
    let {requestedServices} = this.state;
    requestedServices = requestedServices.filter(e => e.name !== service.name);

    if (checked) {
      requestedServices.push(service);
    }
    this.setState({requestedServices, pristine: true});
  };

  onTiresExchangeChange = (tiresExchange, pristine = true) => {
    this.setState({tiresExchange, pristine});
  };

  onTiresReplacementChange = (tiresReplacement, pristine = true) => {
    this.setState({tiresReplacement, pristine});
  };

  render() {
    const {intl, intl:{formatMessage}, intervention, intervention: {journey}, fetchServices, updateJourneyServices: {error = {}}, connectedUserId, canWrite} = this.props;
    const {mainServices = {}, myBMWAppServices = {}, otherServices = {}, additionalServices = {}, extraServices = [], myBMWAppExtraServices = []} = fetchServices.services;
    const {requestedServices = [], tiresExchange = {}, tiresReplacement = {}, pristine} = this.state;
    const {properties:{services={}}} = journey;
    const {valueServicesCart} = services;
    const errors = error.content || {};
    const oas = InterventionService.isOAS(intervention);

    if (!requestedServices) {
      return null;
    }

    const requestedServiceNames = requestedServices.map(s => oas ? s.id : s.name);
    const availableMainServices = [];
    const availableAdditionalServices = [];

    if (oas) {
      Object.values(myBMWAppServices)
        .sort((a, b) => a.order - b.order)
        .forEach(service => (service.active || requestedServiceNames.includes(service.id)) && availableMainServices.push(service));
      availableAdditionalServices.push(...myBMWAppExtraServices)
    } else {
      Object.keys(mainServices).forEach(key => (mainServices[key].active || requestedServiceNames.includes(key)) && availableMainServices.push(mainServices[key]));
      Object.keys(otherServices).forEach(key => (otherServices[key].active || requestedServiceNames.includes(key)) && availableMainServices.push(otherServices[key]));
      Object.keys(additionalServices).forEach(key => (additionalServices[key].active || requestedServiceNames.includes(key)) && availableAdditionalServices.push(additionalServices[key]));
      availableAdditionalServices.push(...extraServices);
    }

    const canAddServices = canWrite && !InterventionService.isComplete(intervention);
    return (
      <Card
        title={formatMessage({id: 'appointment.detail.services.title'})}
        pristine={pristine}
        button={canAddServices &&
          <button onClick={this.onServicesSave} disabled={!pristine} type="primary" className={`btn btn-sm btn-primary`}>
            {formatMessage({id: 'action.save'})}
          </button>
        }
      >

        <div className="box__body">
          {errors && errors.services &&
            <div className="alert alert--error">
              {formatMessage({id: errors.services.message})}
            </div>
          }

          <div className="row">
            {valueServicesCart && <div className="col-md-6 col-xxl-6">
              <ValueServicesCart cart={valueServicesCart}/>
            </div>}
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id:'appointment.detail.services.requested-services.title'})}</h3>

              <ul className="list">
                {availableMainServices.map((s, index) =>
                  <li key={index}>
                    <Checkbox id={s.name} checked={requestedServiceNames.includes(oas ? s.id : s.name)} disabled={!canAddServices} onChange={(checked, e) => this.onServicesChange(e, s)}>
                      {formatMessage({id:`services.${s.name}`})}
                    </Checkbox>
                    {!s.active && <div className={"txt-error"}>{formatMessage({id:'appointment.detail.services.deprecated'})}</div>}
                  </li>
                )}
              </ul>
            </div>
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id: 'appointment.detail.services.additional-services.title'})}</h3>
              <ul className="list">
                {availableAdditionalServices.map((s, index) => {
                  const name = s.mlItem ? s.mlItem[intl.locale] : formatMessage({id: `services.${s.name}`});
                  return (<li key={index}>
                    <Checkbox id={oas ? s.id : s.name} checked={requestedServiceNames.includes(oas ? s.id : s.name)} disabled={!canAddServices} onChange={(checked, e) => this.onServicesChange(e, s)}>{name}</Checkbox>
                    {!s.active && <div className={"txt-error"}>{formatMessage({id: 'appointment.detail.services.deprecated'})}</div>}
                  </li>)
                })}
              </ul>

            </div>
          </div>
          {requestedServiceNames.includes("tiresReplacement") &&
            <div className="row">
              <div className="col-md-12 col-xxl-12">
                <TiresReplacement uuid={journey.uuid} canWrite={canAddServices} connectedUserId={connectedUserId}
                                  errors={errors} tiresReplacement={tiresReplacement} onChange={this.onTiresReplacementChange}/>
              </div>
            </div>
          }
          {requestedServiceNames.includes("tiresExchange") &&
            <div className="row">
              <div className="col-md-12 col-xxl-12">
                <TiresExchange tiresExchange={tiresExchange} canWrite={canAddServices} onChange={this.onTiresExchangeChange} errors={errors}/>
              </div>
            </div>
            }
          {intervention.origin === Constants.ORIGIN_CALL_CENTER.value &&
            <div className="advisor-comment__field" style={{backgroundColor: '#fafafa', marginTop: '20px'}}>
              <p style={{color: '#262626', fontWeight: 'bold'}}><FormattedMessage id={'customer.journey.comment.title'}/></p>
              <p style={{fontStyle: 'italic', wordWrap: 'break-word'}}>{journey.comment}</p>
            </div>
          }
        </div>

      </Card>
    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention,
  fetchServices: state.fetchServices,
  updateJourneyServices: state.updateJourneyServices
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchServices: (parameters, filters) => dispatch({type: 'FETCH_SERVICES.REQUEST', parameters, filters}),
  dispatchUpdateServices: (id, body) => dispatch({type: 'UPDATE_JOURNEY_SERVICES.REQUEST', id, body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AppointmentServicesCard))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/services/AppointmentServicesCard.js